module.exports = __webpack_public_path__ + "static/media/blue_lens.d12c9d01.svg";